<template>
        <NuxtPage></NuxtPage>
</template>

<script setup>

</script>

<style lang="scss" scoped>

</style>